import { Container, Icon } from '@mui/material'

import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import { useLandingZones } from '@features/hooks/LandingZones'
import { useLandingZoneTags } from '@features/hooks/LandingZones/tags'

import Datatable from '@components/Datatable'
import Alert from '@components/Alert'
import Link from '@components/Link'
import Tooltip from '@components/Tooltip'

export const Tags = (props) => {
    const lzDataStore = useSelector(state => state.landingZones)
    const dataStore = useSelector(state => state.landingZoneTags)

    const { load: loadLz } = useLandingZones()
    const { load: loadTags } = useLandingZoneTags()

    const [data, setData] = useState([])
    const [link, setLink] = useState('#')

    const transformDetails = (params) => {
        return (
            <Tooltip title={params.value}>
                <Icon>quick_reference</Icon>
            </Tooltip>
        )
    }

    useEffect(() => {
        if (!(lzDataStore.formated.mode > -1))
            loadLz(() => { loadTags(props.id) })
        else loadTags(props.id)
    }, [])

    useEffect(() => {
        setData(dataStore.formated.grid)
        setLink(dataStore.formated.link)
    }, [dataStore.formated])

    const headers = useRef([
        {field: 'name', headerName: 'Name', flex: 0.2, sortable: false},
        {field: 'value', headerName: 'Value', flex: 1, sortable: false},
        {field: 'info', headerName: 'Details', width: 70, sortable: false, renderCell: transformDetails, align: 'center'}
    ])

    return (
        <Container maxWidth={'xl'} sx={{mt: 2}}>
            <Alert sx={{mb: 2}} description={'Tags are name/value pairs that enable you to categorize resources and view consolidated billing by applying the same tag to multiple resources and resource groups. Tag names are case insensitive, but tag values are Tags are name/value pairs that enable you to categorize resources and view ce case sensitive.'} />
            <Link external href={link} target={'blank'}>Open tag in Azure</Link>
            <Datatable
                emptyText={'No TAGS available'}
                emptyIcon={'scan_delete'}
                sxRoot={{mt: 2}}
                sxGrid={(data.length > 0) ? {height: 'auto'} : {height: '365px'}}
                disableColumnMenu={true}
                disableColumnSorting={true}
                headers={headers.current}
                rows={data}
                getRowId={(row) => row.id}
            />
        </Container>
    )
}

export default Tags